import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import './StaticPages.css';

const PrivacyPolicyPage = () => {
    const { t } = useTranslation();

    return (
        <div className="page-container static-page legal-page">
            <div className="static-header">
                <h1>{t('privacy_policy_title')}</h1>
                <p className="last-updated">{t('last_updated_policy')}</p>
            </div>
            
            <div className="legal-content">
                <p>{t('privacy_intro')}</p>

                <h2>{t('privacy_h2_data_collected')}</h2>
                <p>{t('privacy_p_data_collected_intro')}</p>
                <ul>
                    <li><strong>{t('privacy_li_identity')}:</strong> {t('privacy_li_identity_desc')}</li>
                    <li><strong>{t('privacy_li_contact')}:</strong> {t('privacy_li_contact_desc')}</li>
                    <li><strong>{t('privacy_li_financial')}:</strong> {t('privacy_li_financial_desc')}</li>
                    <li><strong>{t('privacy_li_transaction')}:</strong> {t('privacy_li_transaction_desc')}</li>
                    <li><strong>{t('privacy_li_technical')}:</strong> {t('privacy_li_technical_desc')}</li>
                    <li><strong>{t('privacy_li_usage')}:</strong> {t('privacy_li_usage_desc')}</li>
                    <li><strong>{t('privacy_li_documents')}:</strong> {t('privacy_li_documents_desc')}</li>
                </ul>

                <h2>{t('privacy_h2_how_we_use')}</h2>
                <p>{t('privacy_p_how_we_use_intro')}</p>
                <ul>
                    <li>{t('privacy_li_use_service')}</li>
                    <li>{t('privacy_li_use_manage')}</li>
                    <li>{t('privacy_li_use_improve')}</li>
                    <li>{t('privacy_li_use_legal')}</li>
                </ul>

                <h2>{t('privacy_h2_document_confidentiality')}</h2>
                <p>{t('privacy_p_document_confidentiality')}</p>

                <h2>{t('privacy_h2_data_sharing')}</h2>
                <p>{t('privacy_p_data_sharing')}</p>

                <h2>{t('privacy_h2_data_security')}</h2>
                <p>{t('privacy_p_data_security')}</p>

                <h2>{t('privacy_h2_your_rights')}</h2>
                <p>{t('privacy_p_your_rights')}</p>

                <h2>{t('privacy_h2_contact')}</h2>
                       <p>
            <Trans i18nKey="privacy_p_contact">
                <a href="mailto:info@quadlingua.com" className="text-link" />
            </Trans>
        </p>
            </div>
        </div>
    );
};

export default PrivacyPolicyPage;